/**
 * Fleetly Design System
 * 
 * Port of the mobile theme system to web client
 * Based on mobile Colors.tsx implementation
 */

export const white = '#FFFFFF';

// Fleetly Brand Colors - Core brand palette
export const FleetlyColors = {
  // Primary Brand Colors
  primaryNavy: '#1B3A57',
  secondaryTeal: '#4ECDC4', 
  accentBlue: '#45B7D1',
  accentOrange: '#F96332',
  accentPurple: '#7B3F8C',
  
  // Light Mode
  lightBackground: '#F8F9FA',
  lightSurface: '#FFFFFF',
  lightText: '#1B3A57',
  lightTextSecondary: '#6C757D',
  lightBorder: '#E9ECEF',
  
  // Dark Mode Complements
  darkBackground: '#0F1419',
  darkSurface: '#1B2832',
  darkCard: '#253138',
  darkText: '#FFFFFF',
  darkTextSecondary: '#B8C5D1',
  darkBorder: '#3A4B56',
  
  // Enhanced colors for dark mode
  primaryNavyDark: '#2D4A67',
  secondaryTealDark: '#5ED9D0',
  accentBlueDark: '#52C2E8', 
  accentOrangeDark: '#FF7A4D',
  accentPurpleDark: '#9B5FAE',
};

// Theme variants for light and dark modes
const Themes = {
  light: {
    // Text colors
    text: FleetlyColors.lightText,
    textSubtle: FleetlyColors.lightTextSecondary,
    textGreen: FleetlyColors.secondaryTeal,
    textRed: FleetlyColors.accentOrange,
    textBlue: FleetlyColors.accentBlue,

    // Surface colors
    background: FleetlyColors.lightBackground,
    surface: FleetlyColors.lightSurface,
    border: FleetlyColors.lightBorder,
    card: FleetlyColors.lightSurface,

    // Navigation colors
    tabBarActive: FleetlyColors.accentOrange,
    tabBarInactive: FleetlyColors.lightTextSecondary,

    // Button variants
    btnBg: FleetlyColors.lightBorder,
    btnText: FleetlyColors.lightText,

    btnBgRed: FleetlyColors.accentOrange,
    btnTextRed: white,

    btnBgBlue: FleetlyColors.accentBlue,
    btnTextBlue: white,

    btnBgNavy: FleetlyColors.primaryNavy,
    btnTextNavy: white,

    btnBgGreen: FleetlyColors.secondaryTeal,
    btnTextGreen: white,

    btnBgPurple: FleetlyColors.accentPurple,
    btnTextPurple: white,

    // Component specific colors
    valueText: FleetlyColors.primaryNavy,
    labelText: FleetlyColors.lightTextSecondary,
    timerBackground: FleetlyColors.accentBlue,
    controlBackground: FleetlyColors.lightSurface,
    
    // Navigation specific
    navBarBackground: FleetlyColors.lightSurface,
    navBarText: FleetlyColors.lightText,
    navBarActive: FleetlyColors.accentOrange,
  },
  
  dark: {
    // Text colors
    text: FleetlyColors.darkText,
    textSubtle: FleetlyColors.darkTextSecondary,
    textGreen: FleetlyColors.secondaryTealDark,
    textRed: FleetlyColors.accentOrangeDark,
    textBlue: FleetlyColors.accentBlueDark,

    // Surface colors
    background: FleetlyColors.darkBackground,
    surface: FleetlyColors.darkSurface,
    border: FleetlyColors.darkBorder,
    card: FleetlyColors.darkCard,

    // Navigation colors
    tabBarActive: FleetlyColors.accentOrangeDark,
    tabBarInactive: FleetlyColors.darkTextSecondary,

    // Button variants
    btnBg: FleetlyColors.darkCard,
    btnText: FleetlyColors.darkText,

    btnBgRed: FleetlyColors.accentOrangeDark,
    btnTextRed: white,

    btnBgBlue: FleetlyColors.accentBlueDark,
    btnTextBlue: white,

    btnBgNavy: FleetlyColors.primaryNavyDark,
    btnTextNavy: white,

    btnBgGreen: FleetlyColors.secondaryTealDark,
    btnTextGreen: white,

    btnBgPurple: FleetlyColors.accentPurpleDark,
    btnTextPurple: white,

    // Component specific colors
    valueText: FleetlyColors.darkText,
    labelText: FleetlyColors.darkTextSecondary,
    timerBackground: FleetlyColors.accentBlueDark,
    controlBackground: FleetlyColors.darkCard,
    
    // Navigation specific
    navBarBackground: FleetlyColors.darkSurface,
    navBarText: FleetlyColors.darkText,
    navBarActive: FleetlyColors.accentOrangeDark,
  },

  // Forest theme for variety (ported from mobile)
  forest: {
    text: '#FEFAE0',
    textSubtle: '#FEFAE0',
    textGreen: '#606C38',
    textRed: '#BC6C25',
    textBlue: '#6c25bc',

    background: '#283618',
    surface: '#3A4B2A',
    border: '#606C38',
    card: '#3A4B2A',

    tabBarActive: '#BC6C25',
    tabBarInactive: '#577535',

    btnBg: '#DDA15E',
    btnText: '#FEFAE0',

    btnBgRed: '#BC6C25',
    btnTextRed: '#FEFAE0',

    btnBgBlue: '#6c25bc',
    btnTextBlue: '#FEFAE0',

    btnBgNavy: '#445664',
    btnTextNavy: '#FEFAE0',

    btnBgGreen: '#606C38',
    btnTextGreen: '#FEFAE0',

    btnBgPurple: '#8B6FA3',
    btnTextPurple: '#FEFAE0',

    valueText: '#FEFAE0',
    labelText: '#FEFAE0',
    timerBackground: '#6c25bc',
    controlBackground: '#3A4B2A',
    
    navBarBackground: '#3A4B2A',
    navBarText: '#FEFAE0',
    navBarActive: '#BC6C25',
  },
};

export default Themes;
